// extracted by mini-css-extract-plugin
export var deleteIcon = "_o4-5";
export var deleteOption = "_o4-3";
export var divider = "_o4-2";
export var downloadIcon = "_o4-4";
export var drawer = "_o4-0";
export var drawerFooter = "_o4-6";
export var drawerOpen = "_o4-1";
export var highlighted = "_o4-7";
export var lighterHighlight = "_o4-8";